export default __webpack_public_path__ + "static/media/other.4ce39a7f.jpg";